import { useAdminToast } from '../../Admin/shell/AdminToastContext';
import CotizacionesDashboardView from '../../shared/Cotizaciones/CotizacionesDashboardView';

export const TrimDashboardPage = () => {
    const toast = useAdminToast();
    return <CotizacionesDashboardView toast={toast} />;
};

export default TrimDashboardPage;
